const DEV = 'development';
const PROD = 'production';

export default {
	ENV: (/^localhost|^[0-9]{0,3}\.[0-9]{0,3}\.[0-9]{0,3}\.[0-9]{0,3}/g.test(document.domain) ? DEV : PROD),

	isDev() {
		return (this.ENV === DEV);
	},

	isProd() {
		return (this.ENV === PROD);
	}
};
